import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import DynamicQuantitySelect from 'dibs-dynamic-quantity-select';
import { injectIntl, intlShape } from 'react-intl';
import get from 'lodash.get';
import styles from './PdpSharedQuantitySelect.scss';

class PdpSharedQuantitySelectComponent extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            selectedQuantity: '1',
        };
    }

    onChange(e) {
        const { value } = e.target;

        this.setState({
            selectedQuantity: value,
        });
    }

    getSelectedSku() {
        const { item, selectedSkuId } = this.props;
        const skus = get(item, 'skus') || [];
        const skuId = selectedSkuId || item.defaultSkuId;
        return skus.find(sku => sku.serviceId === skuId);
    }

    isValidCtaQuantity() {
        const selectedSku = this.getSelectedSku();
        const { hasUnlimitedQuantity, quantity } = selectedSku || {};
        const { selectedQuantity } = this.state;
        return hasUnlimitedQuantity || Number(selectedQuantity) <= quantity;
    }

    render() {
        const { children, intl, item } = this.props;
        const { selectedQuantity } = this.state;
        const { isDeleted, isSold } = item;
        const ctaQuantity = this.isValidCtaQuantity() ? selectedQuantity : '1';
        const selectedSku = this.getSelectedSku();
        const { quantity, quantitySelectOptions, setSize } = selectedSku || {};

        if (quantitySelectOptions) {
            const input = (
                <DynamicQuantitySelect
                    availableQuantity={quantity}
                    hasAnimatedPlaceholder
                    intl={intl}
                    onChange={this.onChange}
                    value={selectedQuantity}
                    options={quantitySelectOptions}
                    soldAsSet={setSize && setSize > 1}
                />
            );

            const sellerIsActive = get(item, 'seller.status') === 'active';
            const sellerIsComplimentary = get(item, 'seller.status') === 'nopay';
            const sellerIsInternal = get(item, 'seller.status') === 'internal';
            const showQuantitySelect =
                (sellerIsActive || sellerIsInternal || sellerIsComplimentary) &&
                !isDeleted &&
                !isSold;

            return (
                <div>
                    <div
                        className={`boxSizingWrapper ${styles.quantitySelect}`}
                        data-tn="quantity-select-wrapper"
                    >
                        {showQuantitySelect ? input : null}
                    </div>
                    {children(ctaQuantity)}
                </div>
            );
        } else {
            return children(null);
        }
    }
}

PdpSharedQuantitySelectComponent.propTypes = {
    item: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    selectedSkuId: PropTypes.string,
};

export const PdpSharedQuantitySelect = createFragmentContainer(
    injectIntl(PdpSharedQuantitySelectComponent),
    {
        item: graphql`
            fragment PdpSharedQuantitySelect_item on Item {
                defaultSkuId
                isSold
                isDeleted
                seller {
                    status
                }
                skus {
                    serviceId
                    quantity
                    hasUnlimitedQuantity
                    quantitySelectOptions {
                        label
                        value
                    }
                    setSize
                }
            }
        `,
    }
);
